import mongoose from 'mongoose';
import schema, { ITripHeartDocument } from '../schemas/trip-heart';

const TripHeart = (mongoose.models.TripHeart ||
  mongoose.model('TripHeart', schema)) as mongoose.Model<ITripHeartDocument>;

export default TripHeart;
